import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { FaBars, FaBell, FaLock, FaSignOutAlt, FaUser } from "react-icons/fa";
import Organization from "../pages/Organization/Organization";
import Session from "../pages/Session/Session";
import { getTeacherTimeTableNotification, updateNotificationStatus } from "../services/TeacherSubjectMappingService";
import ThemeToggle from "../components/ThemeToggle/ThemeToggle";
import "./TheHeader.css";

const TheHeader = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const roles = JSON.parse(localStorage.getItem("roles"));
  const roleName = roles ? roles[0].name : '';
  const userID = user ? user.id : '';
  const userNames = user ? user.name : '';

  const [flag, setFlag] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);

  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Fetch notifications and count
  const fetchNotifications = async () => {
    try {
      const response = await getTeacherTimeTableNotification();
      if (response.status === 200) {
        const data = response.data.data;
        setNotificationCount(data.unread_count || 0);
        setNotifications(data.teacher_notifications || []);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // Toggle sidebar
  const toggleSidebar = () => {
    document.body.classList.toggle("open", !flag);
    setFlag(!flag);
  };

  // Logout
  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
    localStorage.removeItem('permissions');
    window.location.reload();
    navigate('/login');
  };

  // Toggle notifications dropdown
  const handleBellClick = (e) => {
    e.stopPropagation();
    setShowNotifications(prev => !prev);
  };

  const viewStatusUpdate = async (notificationId) => {
    try {
      const response = await updateNotificationStatus(notificationId);
      if (response.status === 200) {
        // const data = response.data.data;
        window.open(`/user/profile/${userID}`, "_self");
      }
    } catch (error) {
      console.error("Error fetching notification details:", error);
    }
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <React.Fragment>
      <div className="header-upper row">
        <div className="col-10 left">
          <span className="header-icon-btn" onClick={toggleSidebar} title="Toggle sidebar">
            <FaBars size={18} />
          </span>
        </div>

        <div className="col-2 right d-flex justify-content-end align-items-center">
          <ThemeToggle />
          <div className="position-relative d-inline-block mx-2" ref={dropdownRef}>
            <span className="header-icon-btn header-bell-btn" onClick={handleBellClick} title="Notifications">
              <FaBell size={18} />
              {notificationCount > 0 && (
                <span className="header-notif-badge">{notificationCount}</span>
              )}
            </span>

            {showNotifications && (
              <div className="header-notif-panel">
                <div className="header-notif-panel-title">Notifications</div>
                <ul className="list-unstyled mb-0 header-notif-list">
                  {notifications.length > 0 ? (
                    notifications.map(n => (
                      <li
                        key={n.id}
                        className="header-notif-item"
                        onClick={() => { viewStatusUpdate(n.id) }}
                      >
                        {n.message}
                      </li>
                    ))
                  ) : (
                    <li className="header-notif-empty">
                      No new notifications
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>

          <Navbar bg="none" expand="md" className="navbar-main">
            <Navbar.Collapse>
              <Nav className="navbar-nav-toggle-header">
                <NavDropdown title={`Hi, ${userNames}`} id="basic-nav-dropdown">
                  <NavDropdown.Item as={Link} to={`/user/profile/${userID}`}>
                    <FaUser className="mr-2" /> Profile
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to={`/password/update/${userID}`}>
                    <FaLock className="mr-2" /> Update Password
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={logout}>
                    <FaSignOutAlt className="mr-2" /> Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>

      <div className={`row px-2 py-1 ${roleName === "STAKEHOLDER FEEDBACK" ? "mb-4" : ""}`}>
        {roleName !== "STAKEHOLDER FEEDBACK" && (
          <React.Fragment>
            <div className="col-md-3 pb-mb-2">
              <Organization getOrganisation={props.getOrganisation} />
            </div>
            <div className="col-md-2">
              <Session organisation={props.org_id} />
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default TheHeader;
